import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export async function getTakenSlots(dateISO) {
  const { data } = await api.get(`/contact/bookings/${dateISO}`);
  return data;
}

export async function createBooking(payload) {
  const { data } = await api.post(`/contact/bookings`, payload);
  return data;
}

export async function submitTalentNetwork(payload) {
  const { data } = await api.post(`/careers/talent-network`, payload);
  return data;
}

export async function listOpportunities() {
  const { data } = await api.get(`/careers/opportunities`);
  return data;
}

export async function getPublicConfig() {
  const { data } = await api.get(`/config`);
  return data;
}

export async function createDonationSession(payload) {
  const { data } = await api.post(`/checkout/create-session`, payload);
  return data;
}

export async function getDonationSession(sessionId) {
  const { data } = await api.get(`/checkout/session/${sessionId}`);
  return data;
}
